import React, { useState } from "react";
import { outletMetaData } from "../../features/editAndView/ViewAndEditType";
import { updateOutlet, updateProduct } from "../../services/userService";

import "./OutletModal.css";
import { outletForModelType, outletNewModalType } from "./OutletModalTypes";
import ViewAndEditModal from "../viewAndEditModal/ViewAndEditModal";
import { GenericModalInformation } from "../userModal/ModalState";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";
import { productMetaData } from "../productModal/ProductModalTypes";
import { openPopup } from "../../stateManagement/actions/popupActions";
import store from "../../stateManagement/store";


const GenericViewAndEditModal = ({
    modelData,
    close,
    setGenericMetaData,
    mdmModalConfig,
    buttonText,
    productType
}: outletNewModalType) => {
    const { translate } = usePortalTranslation();
    const CUR_COMPONENT_COMMON="commonPortal";
    const CUR_COMPONENT="GenericModal";
    const [activeButton, setActiveButton] = useState(0);
    const [check, setCheck] = useState(false);
    const [defaultInputs, setDefaultInputs] = useState<outletMetaData>(modelData);
    const {userNameKey} = store.getState().mdmReducer;

    const [editRequestBody, setEditRequestBody] = useState<any>({
        contactName: modelData.outletName,
        outletCode: modelData.outletCode,
        ...(userNameKey && {
            latitude: modelData.latitude,
            longitude: modelData.longitude,
            contactno: modelData.contactno,
            userName: {
                loginId: modelData.userName,
                mobile: modelData.contactno,
                userAccountId: modelData.userName,
            }
        })
    });

    const [defaultImageUrl, setDefaultImageUrl] = useState<string>(modelData.blobKey);
    const [fileName, setFileName] = useState<string>(modelData.fileName);
    const [productRequestBody, setProductRequestBody] = useState<productMetaData>({
        batchCode: modelData.batchCode ? modelData.batchCode: modelData.skuCode,
        skuCode: modelData.skuCode,
        skuName: modelData.skuName,
        category: modelData.category,
        blobKey: defaultImageUrl,
        fileName: fileName,
        skuDescription: modelData.skuDescription,
        subCategory: modelData.subCategory
      });

    const [rejectRequestBody, setRejectRequestBody] = useState<any>({
        extendedAttributes: modelData?.extended_attributes ? JSON.parse(modelData.extended_attributes) : {},
        outletCode: modelData.outletcode
    });
    const localStorageValue = localStorage.getItem("authContext");
    let role: string = ""
    if (localStorageValue !== null) {
      role = JSON.parse(localStorageValue).user?.designation?.[0];
    }
    const [approveRequestBody, setApproveRequestBody] = useState<any>({
        activeStatus: "active",
        extendedAttributes: modelData?.extended_attributes ? {
            ...JSON.parse(modelData.extended_attributes),
            remark: "Outlet Approved",
            role: role,
            status: "Approved",
            adminApproval: "approved"
        } : {
            remark: "Outlet Approved",
            role: role,
            status: "Approved",
            adminApproval: "approved"
        },
        outletCode: modelData.outletcode
    });
    
    const tabNames: string[] = mdmModalConfig?.filter(tab => tab.tabName !== undefined && tab.tabName !== null)?.map(tab => tab.tabName) || [];
    const [validMobile, setValidMobile] = useState(true);


    const changeModalState = (activeButton: number) => {
        const tab = mdmModalConfig?.[activeButton];
        const fields = tab?.fields || [];
        return <GenericModalInformation  setEditRequestBody={productType===true ? setProductRequestBody : buttonText === 'Reject' ? setRejectRequestBody : buttonText === 'Approve' ? setApproveRequestBody : setEditRequestBody} defaultInputs={defaultInputs} setDefaultInputs={setDefaultInputs} setCheck={setCheck} fields={fields} validMobile={{ validMobile, setValidMobile }} setDefaultImageUrl={setDefaultImageUrl} defaultImageUrl={defaultImageUrl} fileName={fileName} setFileName={setFileName}/>;
    };

    const uploadData = async () => {
        if (check || buttonText === "Approve") {
            let requestBodyToUse;
            let response;
            if(productType===true){
                requestBodyToUse = productRequestBody
                requestBodyToUse.blobKey=defaultImageUrl
                requestBodyToUse.fileName=fileName
                response = await updateProduct(requestBodyToUse);
            }else{
                requestBodyToUse = buttonText === "Reject" ? rejectRequestBody : buttonText === 'Approve' ? approveRequestBody : editRequestBody;
                response = await updateOutlet(requestBodyToUse);
            }
            // console.log(response)
            if (response.status === 200 || response.status === 201) {
                setGenericMetaData(translate(TranslationEnum.common_portal,"Successfully updated the data"), "Success", true);
            } else {
                const errorMessage = response?.response?.data?.validation?.violations?.[0]?.message ?? "Some error occured while updating the data";
                setGenericMetaData(
                    errorMessage,
                    "Error",
                    true
                );
            }
        }
        close();
        {check === false && buttonText === "Reject" && openPopup("Error", "Please fill all mandatory fields")}
    };
    return (
        <ViewAndEditModal
            message={translate(TranslationEnum.common_portal,"Edit a record")}
            closeModal={close}
            updateMethod={uploadData}
            check={check}
            buttonText={buttonText}
        >
            <div className="modal-content">
                {tabNames && tabNames.length > 0  && (
                    <div className="modal-states">
                        {tabNames.map((label, index) => (
                            <button
                                key={index}
                                onClick={() => {
                                    setActiveButton(index);
                                }}
                                className={
                                    activeButton === index
                                        ? "active-model-button model-button"
                                        : "model-button"
                                }
                            >
                                {translate(TranslationEnum.generic_modal,label)}
                            </button>
                        ))}
                    </div>
                )}

                {changeModalState(activeButton)}
            </div>
        </ViewAndEditModal>
    );
};

export default GenericViewAndEditModal;
